import { ActionPointInfo, Controller, IActionPointInfo, IDynamicLoader, Loader, Menu, Toolbar, UseAfter } from '@tencent/workbench';
import { config, TOOLBAR_ITEMS } from './config';
import { ShapeFastStyleFeature } from './shape-fast-style-feature';


@Controller({
    toolbarItems: TOOLBAR_ITEMS,
})
export class ShapeFastStyleController {
    public constructor(@Loader(ShapeFastStyleFeature) private loader: IDynamicLoader<ShapeFastStyleFeature>) {
    }

    private get feature() {
        return this.loader.instance!;
    }

    @Toolbar(config.id, 'content')
    public getContent(@ActionPointInfo() info: IActionPointInfo) {
        return this.feature.getContent();
    }

    @Toolbar(config.id, 'shouldDisabled')
    public shouldDisable() {
        return this.feature.shouldDisabled();
    }
}
